import React from "react";
import {
  Box,
  Typography,
  Stack,
  Tooltip,
  IconButton,
  Chip,
  Divider,
} from "@mui/material";
import { StyledCard } from "../common/StyledComponents";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import PaymentsIcon from "@mui/icons-material/Payments";
import InfoRow from "../common/InfoRow";

const getTypeColor = (type) => {
  switch (type) {
    case "CASH":
      return "success";
    case "MOBILE_MONEY":
      return "primary";
    case "BANK_TRANSFER":
      return "secondary";
    default:
      return "default";
  }
};

const PaymentMethodCard = ({ method, onEdit, onDelete }) => {
  return (
    <StyledCard>
      <Box
        sx={{ p: 2, display: "flex", flexDirection: "column", height: "100%" }}
      >
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="flex-start"
          mb={1}
        >
          <Box>
            <Typography variant="h6" fontWeight="bold" noWrap>
              {method.name}
            </Typography>
            <Stack direction="row" spacing={1} mt={0.5}>
              <Chip
                label={method.type.replace("_", " ")}
                size="small"
                color={getTypeColor(method.type)}
                sx={{ height: 20, fontSize: "0.7rem", fontWeight: "bold" }}
              />
              <Chip
                label={method.active ? "Active" : "Inactive"}
                size="small"
                variant="outlined"
                color={method.active ? "success" : "default"}
                sx={{ height: 20, fontSize: "0.7rem" }}
              />
            </Stack>
          </Box>
          <Stack direction="row">
            {onEdit && (
              <Tooltip title="Edit">
                <IconButton size="small" color="secondary" onClick={onEdit}>
                  <EditOutlinedIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
            {onDelete && (
              <Tooltip title="Delete">
                <IconButton size="small" color="error" onClick={onDelete}>
                  <DeleteOutlineIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
          </Stack>
        </Stack>

        <Divider sx={{ my: 1.5 }} />

        <Stack spacing={2} sx={{ flexGrow: 1 }}>
          <InfoRow
            icon={<PaymentsIcon fontSize="small" color="action" />}
            label="Payment Type"
            value={method.type}
          />
        </Stack>
      </Box>
    </StyledCard>
  );
};

export default PaymentMethodCard;
